import { AutocompleteOption } from 'blip-ds/dist/types/components/autocomplete/autocomplete-select-interface';
import { Option } from 'blip-ds/dist/types/components/selects/select-interface';
import { AutoComplete, Button, Grid } from 'components';
import { Skeleton } from 'components/Skeleton/Skeleton';
import { Update } from 'components/Update';
import { Installation } from 'interfaces';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface BotSelectorProps {
    isLoading: boolean;
    installations: Installation[];
    numberOptions: AutocompleteOption[] | undefined;
    groups: Option[];
    handleChangeSelectedGroup: (value: string) => void;
    selectedGroup: number | null;
    handleChangeselectedNumberOptions: (value: AutocompleteOption[]) => void;
}

export const BotSelector: React.FC<BotSelectorProps> = ({
    isLoading,
    installations,
    numberOptions,
    groups,
    handleChangeSelectedGroup,
    selectedGroup,
    handleChangeselectedNumberOptions,
}) => {
    const { t } = useTranslation();
    const [pendingNumberSelection, setPendingNumberSelection] = React.useState<AutocompleteOption[]>([]);

    useEffect(() => {
        setPendingNumberSelection([]);
    }, [selectedGroup]);

    if (isLoading) {
        return (
            <>
                <div>
                    <Skeleton direction="row" skeletons={[{ shape: 'square', width: '300px', height: '40px' }]} />
                </div>
                <Grid gap="half" alignItems="center">
                    <div>
                        <Skeleton direction="row" skeletons={[{ shape: 'square', width: '250px', height: '40px' }]} />
                    </div>
                    <div>
                        <Skeleton direction="row" skeletons={[{ shape: 'square', width: '250px', height: '40px' }]} />
                    </div>
                    <div>
                        <Skeleton direction="row" skeletons={[{ shape: 'square', width: '70px', height: '40px' }]} />
                    </div>
                </Grid>
            </>
        );
    }

    if (!installations.length) {
        return null;
    }

    return (
        <>
            <Update />
            <Grid gap="1" alignItems="center">
                <AutoComplete
                    selectionType="single"
                    options={groups}
                    placeholder={t('go-personal-bot-selector-groups')}
                    selectedOption={selectedGroup?.toString() || ''}
                    handleChange={handleChangeSelectedGroup}
                />
                <AutoComplete
                    id="installation-select"
                    selectionType="multiple"
                    options={numberOptions ?? []}
                    disabled={selectedGroup === null}
                    placeholder={t('go-personal-bot-selector-select-number')}
                    handleMultiselectedChange={(value: AutocompleteOption[]) => {
                        setPendingNumberSelection(value);
                    }}
                />
                <Button
                    variant="primary"
                    color="content"
                    text={t('go-personal-bot-selector-search')}
                    disabled={pendingNumberSelection.length === 0}
                    handleClick={() => {
                        if (pendingNumberSelection.length !== 0)
                            handleChangeselectedNumberOptions(pendingNumberSelection);
                    }}
                />
            </Grid>
        </>
    );
};
